export function anyMatch<T>(arr: T[], matcher: (item: T) => boolean): boolean {
    return arr.some(matcher);
}
